
var cartDrawer = {

  _init: function() {
    this._bindEvents();
  },

  _bindEvents: function() {

    //Open 
    $('.header__icon.header__icon--cart').on('click', function(e) {
      e.preventDefault()
      cartDrawer._open()
    })

    //Close
    $('.custom-cart-drawer__close-btn, .custom-cart-drawer__footer-close-btn').on('click', function(e) {
      e.preventDefault()
      cartDrawer._close()
    })

    $('.custom-cart-drawer-wrapper').on('click', function(e) {
      if(e.target != $('.custom-cart-drawer') && !e.target.closest('.custom-cart-drawer')) {
        cartDrawer._close()
      }
    })

  },

  _open: function() {
    $('.custom-cart-drawer-wrapper').fadeIn()
    $('.custom-cart-drawer').css('margin-right', 0)
  },

  _close: function() {
    $('.custom-cart-drawer-wrapper').fadeOut()
    $('.custom-cart-drawer').css('margin-right', '-100%')
  },

  _addItems: function(cart) {
    $('.custom-cart-drawer__cart-items-inner').html(' ')

    //Update Subtotal Price
    cartDrawer._updateSubtotal(cart)

    //Add Items
    $.each(cart.items, function(i, d) {
      const itemDom = $('#custom_cart_drawer__cart_item_block_dom').clone()

      itemDom.removeAttr('id')
      itemDom.data('variant-key', d.key)
      itemDom.find('.custom-cart-drawer__cart-item-image-container img').attr('src', d.image)
      itemDom.find('a').attr('href', d.url)
      itemDom.find('.custom-cart-drawer__cart-item-title-wrapper h4').html(d.product_title)
      itemDom.find('.custom-cart-drawer__cart-item-final-price').html('$'+ (d.final_price / 100))
      itemDom.find('.custom-cart-drawer__cart-item-quantity-input').val(d.quantity)

      if(d.properties) {
        $.each(d.properties, function(key, value) {
          const propertyItem = $(`
            <p class="custom-cart-drawer__cart-item-property">
              <span>${key}: </span>
              <span>${value}</span>
            </p>`)
          propertyItem.appendTo(itemDom.find('.custom-cart-drawer__cart-item-properties-wrapper'))
        })
      }

      if(d.selling_plan_allocation != undefined && d.selling_plan_allocation != null) {
        const subscriptionItem = $(`
          <p class="custom-cart-drawer__cart-item-property">
            <span>Subscription: </span>
            <span>${d.selling_plan_allocation['selling_plan']['name']}</span>
          </p>`)
          subscriptionItem.appendTo(itemDom.find('.custom-cart-drawer__cart-item-properties-wrapper'))
      }

      //Quantity
      itemDom.find(".custom-cart-drawer__cart-item-quantity-minus").on("click", function() {
        let $input = $(this).siblings("input[type=number]");
        let value = parseInt($input.val()) || 0;
        if (value > 0) {
          $input.val(value - 1).trigger("change");
        }
      });

      itemDom.find(".custom-cart-drawer__cart-item-quantity-plus").on("click", function() {
        let $input = $(this).siblings("input[type=number]");
        let value = parseInt($input.val()) || 0;
        $input.val(value + 1).trigger("change");
      });

      //Actions
      itemDom.find('.custom-cart-drawer__cart-item-quantity-input').on("change", debounce(function() {
        cartDrawer._updateQuantity(itemDom.data('variant-key'), itemDom.find('.custom-cart-drawer__cart-item-quantity-input').val(), itemDom)
      }, 250))

      itemDom.find('.custom-cart-drawer__cart-item-action-remove').on("click", function() {
        cartDrawer._updateQuantity(itemDom.data('variant-key'), 0, itemDom)
      })

      itemDom.show()
      itemDom.appendTo('.custom-cart-drawer__cart-items-inner')
    })

    //Free Shipping Progress
    cartDrawer._freeShippingProgress(cart.items_subtotal_price/100)

    //Undo Empty Cart
    cartDrawer._emptyCartCheck(false)
  },

  _updateQuantity: function(key, value, item) {
    let formData = {
      'id': key,
      'quantity': value
    };
    
    //start loading
    $('.custom-cart-drawer__cart-items-inner-loading-wrapper').fadeIn();

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    }).then(
      function(state) {

        if(value == 0) {
          item.fadeOut()
        }

        //Update Subtotal Price
        cartDrawer._updateSubtotal(state)
        
        //Free Shipping Progress
        cartDrawer._freeShippingProgress(state.items_subtotal_price / 100)

        if(state.items.length == 0) {
          cartDrawer._emptyCartCheck(true)
        }
        
        //hide loading
        $('.custom-cart-drawer__cart-items-inner-loading-wrapper').fadeOut();
      }.bind(this)
    )
    .catch(
      function(error) {
        console.log(error)
      }.bind(this)
    );
  },

  _updateSubtotal: function(items) {
    $('.custom-cart-drawer__header-total, .custom-cart-drawer__footer-subtotal-amount').html('$' + (items.items_subtotal_price / 100).toFixed(2) + ' AUD');
    $('.header-cart-item-count, .custom-cart-drawer__header-title span').html(items.items.length)
  },

  _freeShippingProgress: function(subtotal) {
    let freeShippingCap = $('.custom-cart-drawer__free-ship-notification-text').data('amount')
    let freeShippingProgress = freeShippingCap - subtotal

    if(freeShippingProgress < 0.1) {
      $('.custom-cart-drawer__free-ship-notification-text').html('You just unlocked FREE SHIPPING!')
      $('.custom-cart-drawer__free-ship-notification-bar span').css('width', '100%')
    }
    else {
      $('.custom-cart-drawer__free-ship-notification-text').html('You\'re only <span>$'+freeShippingProgress.toFixed(2)+'</span> away from free shipping.')
      $('.custom-cart-drawer__free-ship-notification-bar span').css('width', ((subtotal/freeShippingCap) * 100) + '%')
    }
  },

  _emptyCartCheck: function(empty) {
    if(empty) {
      $('.custom-cart-drawer__footer-close-btn').show()
      $('.custom-cart-drawer__footer-wrapper').hide()
      $('.custom-cart-drawer__cart-empty-items').show()
    }
    else {
      $('.custom-cart-drawer__footer-close-btn').hide()
      $('.custom-cart-drawer__footer-wrapper').show()
      $('.custom-cart-drawer__cart-empty-items').hide()
    }
  }

}